import React, { useContext, useEffect, useState } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button, Typography, LinearProgress } from '@material-ui/core';
import { makeStyles } from "@material-ui/styles";
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import * as actions from "../actions/actions";

const useStyles = makeStyles((theme) => ({
  popupButton: {
    justifyContent: "flex-end"
  },
}));

export default function ConfirmationDialog() {
  const state = useContext(AppContext);
  const s = state.strings;
  const dispatch = useContext(DispatchContext);
  const classes = useStyles();
  const [confirmed, setConfirmed] = useState(false);

  const { onConfirm, onCancel, payload, title, text, hint, visible, waitingMessage, okLabel, cancelLabel } = state.ui.confirmationDialog;

  useEffect(() => {
    if (state.ui.confirmationDialog.visible) {
      setConfirmed(false);
    }
  }, [state.ui.confirmationDialog.visible]);


  const handleConfirm = () => {
    if (!waitingMessage) {
      dispatch(actions.closeConfirmationDialog());
    }
    setConfirmed(true);
    onConfirm && onConfirm(payload);
  }

  const handleCancel = () => {
    dispatch(actions.closeConfirmationDialog());
    onCancel && onCancel(payload);
  }

  return (
    <Dialog maxWidth="xs" onClose={handleCancel} open={visible} >
      <DialogTitle >
        {title}
      </DialogTitle>
      <DialogContent dividers>
        {(waitingMessage && confirmed) ?
          <Grid container>
            <Typography paragraph>{text}</Typography>
            <Typography variant="body2" color="secondary">{waitingMessage}</Typography>
            <LinearProgress style={{ width: "100%" }} />
          </Grid>
          :
          <Grid container>
            <Typography paragraph>{text}</Typography>
            {hint && (<Typography variant="body2" color="secondary">{hint}</Typography>)}
          </Grid>}
      </DialogContent>
      <DialogActions className={classes.popupButton} >
        <Button disabled={confirmed} variant="outlined" color="primary" onClick={handleCancel}>
          {cancelLabel ? cancelLabel : onConfirm ? s.common.no : s.common.ok}
        </Button>
        {onConfirm && <Button disabled={confirmed} variant="contained" color="primary" onClick={handleConfirm}>
          {okLabel ? okLabel : s.yes}
        </Button>}
      </DialogActions>
    </Dialog>
  )
}